export type TemperatureUnit = 'imperial' | 'metric';

export const getTemperatureUnit = (
  locale: string | undefined
): TemperatureUnit => {
  const isImperial = !locale || locale === 'en' || locale === 'en-us';

  return isImperial ? 'imperial' : 'metric';
};
